import { Comparison } from "../types/function"

export default <T>(a: T, b: T): Comparison => a > b ? 1 : a < b ? -1 : 0
